import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { getHandbook } from 'api/clients/HandbookClient'
import { ReactComponent as SettingsIcon } from 'assets/icons/settings16.svg'
import { useHandbook } from 'components/Handbook2_0/hooks'
import { getFolderPath } from 'utils/urlUtils'

import { ActionKey } from '../../Types'

export const useSettingsEditable = (key: string | undefined) => {
  const [shouldFetchHandbook, setShouldFetchHandbook] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()
  const currentHandbook = useHandbook()

  useEffect(() => {
    if (!shouldFetchHandbook) return

    const fetchHandbook = async () => {
      if (!key) return

      const res = await getHandbook(key)
      const { handbook } = res.data
      setShouldFetchHandbook(false)

      if (!handbook) return

      history.push(`${getFolderPath({ folderSlug: handbook.seo_string })}/settings`)
    }

    fetchHandbook()
  }, [shouldFetchHandbook, setShouldFetchHandbook, dispatch, history, key, currentHandbook])

  const handleSettingsEditable = (actionKey: ActionKey) => {
    if (actionKey !== ActionKey.settings) return false
    setShouldFetchHandbook(true)
    return true
  }

  return {
    settings: [
      {
        key: ActionKey.settings,
        textValue: 'Folder settings',
        Icon: SettingsIcon,
      },
    ],
    handleSettingsEditable,
  }
}
